import { Component, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'pps-html-tooltip',
  template: `<div class="html-tooltip" [innerHTML]="html"></div>`,
  styles: [
    `
    .html-tooltip {
      max-width: 420px;
      white-space: normal;
      line-height: 1.3;
      word-break: break-word;
      background-color: #f5f5f5;
      padding: 8px;
      border-radius: 4px;
      border: 1px solid #ccc;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    }
    `
  ]
})
export class HtmlTooltipComponent implements ITooltipAngularComp {
  html = '';

  constructor(private sanitizer: DomSanitizer) {}

  agInit(params: ITooltipParams): void {
    const value = params?.valueFormatted ?? params?.value;
    const rawHtml = value == null ? '' : String(value);
    this.html = this.sanitizer.sanitize(SecurityContext.HTML, rawHtml) || '';
  }
}
